const BadgeCardText =
       "Here's your chance to earn some cash, increase your salary or increase your mood points. " +
       "Just click on the Earn a Badge button."
    
export default BadgeCardText;